<template>
  <div class="News" id="News">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='Pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  新闻中心
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_news.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <div class="titleBox" id="part1">
                <h1 class="second_title font-weight-thin lg-4">
                  最新动态
                </h1>
              </div>
              <div class="text-center">
                <v-container width="100%">
                  <v-row justify="center">
                    <v-col cols="12">
                     <v-container>
                      <v-row dense>
                        <v-col
                          v-for="items in newsList"
                          :key="items.id"
                          cols="12"
                        >
                          <v-card color="white" height='20rem' style="margin-bottom:3rem;" elevation="6" class='rounded-lg' width='100%' v-show="Pc">
                            <div class="d-flex flex-no-wrap">
                              <v-avatar
                                class="ma-3"
                                size="18rem"
                                tile
                              >
                                <v-img :src="items.fmimg"></v-img>
                              </v-avatar>

                              <div style="position:relative;height:19rem;display:flex;align-items:flex-start;flex-direction:column;justify-content:center;margin-left:1rem;margin-right:3rem;">
                                <p class="body_text" style="font-size:1.5rem;">{{items.xwbt}}</p>

                                <p class="body_text" style="position:relative;text-align:left;">{{items.xwgs}}</p>

                                <v-btn outlined color="primary" class="btn-blue" :to="{path:'/newsDetails',query:{id:items.id}}">了解更多</v-btn>
                              </div>
                            </div>
                          </v-card>
                          <v-card class="mx-auto" height="26rem"  width="360" color="white" elevation='8' v-show="!Pc">
                            <v-img
                            :src="items.fmimg"
                            gradient="to top right, rgba(63, 81, 181,.1), rgba(63, 81, 181,.1)"
                            height="12rem"
                            >
                            </v-img>
                            <v-card-text>
                              <div class="news-text">
                                <div class="news-date">
                                  <h2 class="primary--text text-center third_title" style="line-height:1.2">{{items.fbdate.date}}</h2>
                                  <p>{{items.fbdate.year}}<br>{{items.fbdate.month}}</p>
                                </div>
                                <h2 class='body_text' v-text="items.xwbt"></h2>
                              </div>
                            </v-card-text>
                            <v-fade-transition>
                              <v-btn class="news-btn" :to="{path:'/newsDetails',query:{id:items.id}}" text plain color="fontColor">查看详情<v-icon>mdi-arrow-right</v-icon></v-btn>
                            </v-fade-transition>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'

export default {
  name: 'News',

  components: {
    FootContent,
    FirstNavbar
  },
  data: () => ({
    // 屏幕宽度
    Pc: true,
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 5,
    newsList: [],
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    }
  }),
  mounted () {
    this.goTo(0)
    this.getNews()
    this.whatScreen()
    var that = this
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.Pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.Pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.Pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.Pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.Pc = true
              }
            }
          }
        }
      }
    },
    // 获取新闻信息
    async getNews () {
      const { data: res } = await this.$axios.post('erp/f/web/getXwInforList')
      const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      this.newsList = res
      this.newsList.forEach((val, index, arry) => {
        // 日期转换为中文
        this.newsList[index].fbdate = {
          month: monthList[this.newsList[index].fbdate.split(' ')[0].split('-')[1] - 1],
          year: this.newsList[index].fbdate.split(' ')[0].split('-')[0],
          date: this.newsList[index].fbdate.split(' ')[0].split('-')[2]
        }
        this.newsList[index].fmimg = this.baseUrl + 'erp/' + res[index].fmimg.split('/erp/')[1]
      })
      // /wtpwebapps/
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    }
  }

}
</script>

<style>

</style>
